import type { ConsentState } from "./types";

const REPROMPT_MS = 1000 * 60 * 60 * 24 * 396; // ~13 months

export function needsBanner(state: ConsentState | null, configVersion: string, now: Date): boolean {
  if (!state) return true;
  if (state.version !== configVersion) return true;
  const decided = new Date(state.decidedAt).getTime();
  return now.getTime() - decided > REPROMPT_MS;
}

export function isGranted(state: ConsentState | null, categoryKey: string): boolean {
  return state?.categories?.[categoryKey]?.status === "given";
}
